<template>
  <div class="quad-pack">
    <div class="root" ref="root" v-resize:throttle="resized"></div>
  </div>
</template>

<script>
// import * as d3 from 'd3'
import d3 from "@/utils/d3Importer";
import resize from "vue-resize-directive";
import NicePacking from "./NicePacking";
import { RouteNames } from "../../router";
export default {
  name: "quadpack",
  directives: {
    resize: resize,
  },
  props: ["proportions", "heroIngredient"],
  computed: {
    size: () => {
      return {
        width: this.$refs.root.clientWidth,
        height: this.$refs.root.clientHeight,
      };
    },
  },
  watch: {
    proportions: function () {
      this.draw();
    },
  },
  methods: {
    resized() {
      this.draw();
    },
    draw() {
      const height = 100;
      const width = 100;
      const packMargin = 4;

      let pack = NicePacking()
        .size([width, height])
        .value((d) => d.proportion);

      var data = JSON.parse(JSON.stringify(this.proportions));

      if (this.heroIngredient) {
        let candidate = data.find(
          (p) => p.ingredient.id === this.heroIngredient.id
        );
        if (candidate) candidate.proportion *= 2;
      }

      data.sort((a, b) => b.proportion - a.proportion);
      data = data.filter((d) => d.proportion > 0).slice(0, 5);

      let packData = pack(data);

      let items = d3
        .select(this.$refs.root)
        .selectAll(".item")
        .data(packData, (d) => d.data.ingredient.id);
      let itemsEnter = items.enter().append("div").attr("class", "item");
      // itemsEnter
      //   .on('click',(d)=>{
      //     this.onSelect && this.onSelect(d.data.ingredient.id)
      //   })
      itemsEnter
        .style("position", "absolute")
        .style("left", function (d) {
          return "calc( " + d.x0 + "% + " + packMargin / 2 + "px)";
        })
        .style("top", function (d) {
          return "calc( " + d.y0 + "% + " + packMargin / 2 + "px)";
        })
        .style("width", function (d) {
          return "calc( " + (d.x1 - d.x0) + "% - " + packMargin + "px)";
        })
        .style("height", function (d) {
          return "calc( " + (d.y1 - d.y0) + "% - " + packMargin + "px)";
        })
        .style("cursor", (d) =>
          d.data.ingredient.isIngredientChapter ? "pointer" : "auto"
        )
        .style("opacity", 0);

      itemsEnter
        .append("div")
        .attr("class", "ing-name")
        .append("div")
        .attr("class", "ing-name-label")
        .text((d) => d.data.ingredient.name);
      let defaultColorClass =
        this.defaultColor === "HEAVY" ? " black" : " white";
      itemsEnter.classed(defaultColorClass, true);
      itemsEnter.each(function (d) {
        let img = new Image();
        img.onload = () => {
          d3.select(this).append(() => img);
        };
        img.onerror = () => {
          if (d.data.ingredient.family)
            d3.select(this).style(
              "background-color",
              d.data.ingredient.family.color
            );
          else d3.select(this).classed("no-image", true);
          // d3.select(this).append('div').attr('class','ing-name').text(d.data.ingredient.name)
        };
        img.src = d.data.ingredient.imageUrlM || d.data.ingredient.imageUrl;
        // img.src = imageProvider.getImageUrl('ingredients/'+d.data.ingredient.imageUrl)
      });

      itemsEnter.on("click", (e, d) => {
        if (d.data.ingredient.isIngredientChapter)
          this.$router.push({name:RouteNames.IngredientChapter, query:{data:d.data.ingredient.id}});
      });

      items.exit().transition().duration(600).style("opacity", 0).remove();

      items = items.merge(itemsEnter);
      items.classed("selected", (d) => {
        return this.selection && d.data.ingredient.id === this.selection;
      });
      items.classed("unselected", (d) => {
        return this.selection && d.data.ingredient.id !== this.selection;
      });
      items
        .style("left", function (d) {
          return "calc( " + d.x0 + "% + " + packMargin / 2 + "px)";
        })
        .style("top", function (d) {
          return "calc( " + d.y0 + "% + " + packMargin / 2 + "px)";
        })
        .style("width", function (d) {
          return "calc( " + (d.x1 - d.x0) + "% - " + packMargin + "px)";
        })
        .style("height", function (d) {
          return "calc( " + (d.y1 - d.y0) + "% - " + packMargin + "px)";
        })
        .transition()
        .duration(600)
        .delay((d, i) => i * 100)
        .style("opacity", 1);
      items
        .select(".ing-name")
        .select(".ing-name-label")
        .text((d) => d.data.ingredient.name);
    },
  },
};
</script>

<style scoped lang="stylus">
.quad-pack
  position: relative

  &:after
    content: ""
    display: block
    padding-bottom: 100%

  .root
    height: 100%
    position: absolute
    width: 100%

    /deep/ .item
      background-position: center
      background-repeat: no-repeat
      background-size: cover
      overflow: hidden
      transition: width 0.4s ease-in-out, height 0.4s ease-in-out, top 0.4s ease-in-out, left 0.4s ease-in-out

      // background: #f0a !important;
      &.no-image
        display: flex
        flex-direction: column
        justify-content: center

        &.black
          background: #000
          color: #fff

        &.white
          background: #fff
          color: #000

        img
          display: none

      &.selected,
      &.unselected
        opacity: 0.5 !important

      img
        height: 100%
        object-fit: cover
        overflow: hidden
        transition: filter 0.6s
        width: 100%

      .ing-name
        background: rgba(255, 255, 255, 0.5)
        height: 100%
        opacity: 0
        position: absolute
        transition: opacity 0.3s
        width: 100%
        z-index: 1

        .ing-name-label
          m-font("WaverlyCF", "regular")
          m-font-size(14, 16)
          left: 50%
          position: absolute
          text-align: center
          top: 50%
          transform: translate(-50%, -50%)

          .mobile &
            m-font-size(12, 14)

      &.black
        .ing-name
          background: rgba(0, 0, 0, 0.5)

          .ing-name-label
            color: #fff
            text-shadow: 0 1px 10px #000

      &.white
        .ing-name
          background: rgba(255, 255, 255, 0.5)

          .ing-name-label
            color: #000
            text-shadow: 0 1px 10px #fff

      &:hover
        .ing-name
          opacity: 1

        img
          filter: blur(4px)
</style>